export const ADDENDUM_NOTE_ADDED = "ADDENDUM_NOTE_ADDED";
